import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import AddMockupTraderForm from '../../components/admin/AddMockupTraderForm';

/**
 * Admin page for adding unclaimed businesses.
 * This is a universal page that works for all business types (Tradesman, Craftsman, Hospitality, Professional).
 * No confirmation email is sent - the business is created with mockup=true and user_id=null.
 */
const AddBusiness = () => {
  const navigate = useNavigate();

  // Handle successful business creation
  const handleSave = (newBusiness: any) => {
    console.log('New unclaimed business created:', newBusiness);
    // Navigate back to the appropriate admin page based on business type
    // For now, go back to dashboard
    navigate('/admin');
  };

  // Handle form close (cancel)
  const handleClose = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-6">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Add Unclaimed Business</h1>
        <p className="text-gray-600 mt-1">
          Create a business listing that can be claimed by the real owner later.
          This works for all business types: Tradesman, Craftsman, Hospitality, and Professional Services.
        </p>
      </div>

      {/* Form - rendered inline instead of as a modal */}
      <div className="bg-white rounded-lg shadow-sm">
        <AddMockupTraderForm
          onClose={handleClose}
          onSave={handleSave}
          isModal={false}
        />
      </div>
    </div>
  );
};

export default AddBusiness;
